import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as styles from './LoadingIndicator.module.scss';

interface LoadingIndicatorProps {
  delay?: number;
  adaptColor?: boolean;
}

const LoadingIndicator = ({
  delay = 500,
  adaptColor = false,
}: LoadingIndicatorProps) => {
  const [isWaiting, setWaiting] = useState(delay > 0);

  useEffect(() => {
    const timeout =
      delay > 0 && isWaiting && setTimeout(() => setWaiting(false), delay);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  });

  return isWaiting ? null : (
    <div
      role="status"
      aria-label="Loading"
      className={classNames(styles.wrapper, {
        [styles.adaptColor]: adaptColor,
      })}
    >
      <div aria-hidden className={styles.dot} />
      <div aria-hidden className={`${styles.dot} ${styles.middle}`} />
      <div aria-hidden className={`${styles.dot} ${styles.last}`} />
    </div>
  );
};

export default LoadingIndicator;
